document.addEventListener('DOMContentLoaded', function () {
	naja.initialize();
});